import {
  CreateAccountProvisionErrors,
  CreateAccountProvisionLoginIDErrors,
  CreateAccountValidationErrors,
  ErrorCode
} from 'features/CreateAccount/enums';
import {buildResponseErrorFromPayload} from 'types/Error';

export const decodeCreateAccountProvisionError = (payload: any): CreateAccountProvisionErrors => {
  const responseError = buildResponseErrorFromPayload(payload);
  switch (responseError.status) {
    case '400':
      return payload?.response?.data?.errors[0]?.code === ErrorCode.ALREADY_EXISTS
        ? CreateAccountProvisionErrors.ALREADY_EXISTS
        : CreateAccountProvisionErrors.NO_UNIQUE_ACCOUNT_FOUND;
    case '403':
      return CreateAccountProvisionErrors.WEB_USE_DISABLED;
    case '409':
      return CreateAccountProvisionErrors.CONFLICT;
    case '500':
    default:
      return CreateAccountProvisionErrors.INTERNAL_SERVER_ERROR;
  }
};

export const decodeCreateAccountProvisionLoginIDError = (payload: any): CreateAccountProvisionLoginIDErrors => {
  const responseError = buildResponseErrorFromPayload(payload);
  switch (responseError.status) {
    case '400':
      return payload?.response?.data?.errors[0]?.code === ErrorCode.ALREADY_EXISTS
        ? CreateAccountProvisionLoginIDErrors.ALREADY_EXISTS
        : CreateAccountProvisionLoginIDErrors.NO_UNIQUE_ACCOUNT_FOUND;
    case '403':
      return CreateAccountProvisionLoginIDErrors.INVALID_TOKEN;
    case '404':
    case '409':
      return CreateAccountProvisionLoginIDErrors.CONFLICT;
    case '500':
    default:
      return CreateAccountProvisionLoginIDErrors.INTERNAL_SERVER_ERROR;
  }
};

export const decodeCreateAccountValidationError = (payload: any): CreateAccountValidationErrors => {
  const responseError = buildResponseErrorFromPayload(payload);
  switch (responseError.status) {
    case '400':
      return CreateAccountValidationErrors.MISMATCH;
    case '409':
      return CreateAccountValidationErrors.NOT_FOUND;
    case '423':
      return CreateAccountValidationErrors.LOCKED;
    case '500':
    default:
      return CreateAccountValidationErrors.INTERNAL_SERVER_ERROR;
  }
};
